/**
 * Program Monthly Attendance Breakdown Service
 * Register Angular Service for the Monthly Attendance breakdown
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 * @return    Resource
 */
import angular from 'angular';

angular.module('flsServices').factory('ProgramMonthlyCounts', ['$resource', function($resource){
    return $resource('/api/aggregate/v1/program-monthly-counts');
}]);
